export interface ApiResponseModel<T> {
  result: T | any;
  message?: string;
}
